import { Box, Paper, Typography } from '@mui/material';
import { Link } from 'react-router';

import type { LlmCostAthena } from '@/lib/types/dashboard/llmCost';
import { formatBytes, formatUsd } from './format';

/** 同期間の owl Athena スキャン（Agent principal）の参考値 */
export function LlmCostAthenaCard({ athena }: { athena: LlmCostAthena | null }) {
  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" mb={1}>
        参考: owl Athena スキャン
      </Typography>
      {athena === null ? (
        <Typography variant="body2" color="text.secondary">
          取得できませんでした（commonDB mcp_usage_logs）。
        </Typography>
      ) : (
        <Box display="flex" gap={4} flexWrap="wrap">
          <Box>
            <Typography variant="body2" color="text.secondary">
              クエリ数
            </Typography>
            <Typography variant="h6">{athena.queryCount.toLocaleString()}</Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">
              走査量
            </Typography>
            <Typography variant="h6">{formatBytes(athena.scannedBytes)}</Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">
              原価（試算 $5/TB）
            </Typography>
            <Typography variant="h6">{formatUsd(athena.estimatedCostUsd)}</Typography>
          </Box>
        </Box>
      )}
      <Typography variant="caption" color="text.secondary" display="block" mt={1}>
        principal <code>{athena?.principal ?? 'agent:sazae-dashboard-agent'}</code> の期間 ×
        アカウント集計（ジョブ単位の紐付けは無い）。詳細は{' '}
        <Link to="/ai/mcp-usage">MCP利用状況</Link> で種別「すべて」を選び principal で絞る。
      </Typography>
    </Paper>
  );
}
